import styled from "styled-components";
import { STYLE_TYPE } from "../../Utils/magicStrings";
import { maxSize, px2vw } from "../../Utils/common";

export const PrivacyWrapper = styled('div')`
    background: #F8F5F1;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
`;

export const PrivacyText = styled('div')`
background: #FFFFFF;
border-radius: 10px;

display: flex;
flex-direction:column;
align-items: center;
    ${props => {
        if(props.styleType !== STYLE_TYPE.MOBILE) {
            return `
                width: min(${px2vw(833)}, 833px);
                margin: auto;
                margin-top: min(${px2vw(47)}, 47px);
            `
        }
    } }
`;

export const PrivacyTitle = styled('div')`
    color: #B69A67;
    width: 100%;
    ${props => maxSize(56, props.styleType, 'margin-top', 24)};
    text-align: center;
    ${props => maxSize(24, props.styleType, 'font-size', 14)};
`;

export const PrivacyContent = styled('div')`
    margin: auto;
    ${props => maxSize(32, props.styleType, 'margin-top', 8)};

    ${props => maxSize(14, props.styleType, 'font-size', 12)};
    ${props => maxSize(608, props.styleType, 'width', 303)};

    ${props => maxSize(28, props.styleType, 'line-height', 14)};
`;